import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloat from "../DynamicDTFloat";
import DynamicDTFloatTabs from "../DynamicDTFloatTabs";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";
import { nw04_report_json_format, generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen } from "../../utils";

import MultiSelectOptions from "./../MultiSelectOptions";
import MultiSheetProcessingLoader from "../MultiSheetProcessingLoader";
import ProcessLoader from "../ProcessLoader";


const BM13 = () => {

    const navigate = useNavigate();

    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);
    const [SelectedDepo, setSelectedDepo] = useState(depo_data.data[0].value);
    const [SelectedStartMonth, setSelectedStartMonth] = useState(month_data.data[0].value);
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [unitValue, setUnitvalue] = useState(2);
    const [ReportType, setReportType] = useState(1);
    const [ReportOption, setReportOption] = useState(1);
    const [groupLoader, setGroupLoader] = useState(true);
    const [GroupListItems, setGroupListItems] = useState([]);
    const [SelectedGroup, setSelectedGroup] = useState(0);
    const [productReportData, setProductReportdata] = useState([]);
    const [tabLoader, setTabLoader] = useState([]);
    const [sheetloaderMessage, setSheetLoaderMessage] = useState("");
    const [productListItems, setProductListItems] = useState([]);
    const [reportGenerationCompleted, setReportGenerationCompleted] = useState(false);
    const [reportDataReady, setReportDataReady] = useState(false);
    const [MultiSheetDownloadStart, setMultiSheetDownloadStart] = useState(false);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [pageTitle, setPageTitle] = useState('');
    const [productlistLoading, setProductlistLoading] = useState(true);
    const [itemType, setItemType] = useState(1);

    useEffect(() => {

        if (reportGenerationCompleted) {
            setReportDataReady(true);
        }
    }, [reportGenerationCompleted]);

    const loadProductItems = async (division, year) => {
        setProductlistLoading(true);

        const payload = {};
        const dataAPIResponse = await proxy(`/api/mis/productlist/${division}/${year}/0`, payload, "get");
        const converted_list = convertProductData(dataAPIResponse);
        setProductListItems(converted_list);
        setSelectedGroup(0);
        setProductlistLoading(false);

    }

    function convertProductData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['value'],
                label: item['name']
            }));
            return converted_list;
        }
        return [];
    }


    useEffect(() => {
        if (reportDataReady) {
            var multiReportTitle = [];

            var reportJson = {};
            reportJson.fileName = "10-Selective Product Mnth/Cumm Form 6-" + SelectedYear + ".xlsx";
            reportJson.title = "10-Selective Product Mnth/Cumm Form 6";
            reportJson.author = "Aristo Pharma";


            reportJson.sheets = [];
            productReportData.map((singlereport, index) => {

                reportJson.sheets.push({
                    name: SelectedGroup[index].value.toString().trim(),
                    data: []
                })
                multiReportTitle.push(singlereport.data.title);

                if (singlereport.data.data.length > 0) {

                    const columns = Object.keys(singlereport.data.data[0]).filter(key => key !== 'color');
                    const headerFormatted = columns.map(key => getHeaderColNames(key));



                    reportJson.sheets[index].data.push({
                        backgroundColor: "#0043a9",
                        fontColor: "#FFFFFF",
                        fontSize: 13,
                        bold: true,
                        values: headerFormatted
                    });

                    const backgroundColors = excelColorCodes;

                    singlereport.data.data.forEach(item => {
                        const row = {
                            backgroundColor: backgroundColors[item.color] || "",
                            fontColor: item.color === 2 ? "#333333" : "#333333",
                            fontSize: 12,
                            bold: false,
                            values: columns.map(col => item[col])
                        };
                        reportJson.sheets[index].data.push(row);
                    });

                } else {

                    const columns = ['NoData'];
                    const item = { "NoData": "No Data" }
                    const headerFormatted = ["No Data"];
                    reportJson.sheets[index].data.push({
                        backgroundColor: "#0043a9",
                        fontColor: "#FFFFFF",
                        fontSize: 13,
                        bold: true,
                        values: headerFormatted
                    });
                    const row = {
                        backgroundColor: "",
                        fontColor: "#333333",
                        fontSize: 12,
                        bold: false,
                        values: columns.map(col => item[col])
                    };
                    reportJson.sheets[index].data.push(row);

                }
            });

            generateExcel(reportJson, 40, 20, 0, 3, multiReportTitle).catch(console.error);

            setReportDataReady(false);
            setMultiSheetDownloadStart(false);
            setReportGenerationCompleted(false);
        }
    }, [reportDataReady]);


    const generateProductReport = async (productCode) => {
        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "hq_code": parseInt(productCode),
            "uv": unitValue,
            "rep_type": ReportType,
            "item_type": itemType

        }

        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/mktrepo2product`, payload, "get");




        var processedReportData = [];

        if (reportAPIResponse == '') {


            processedReportData = { title: "NO DATA", data: [] };

        } else {

            // processedReportData = nw04_report_json_format(reportAPIResponse);
            processedReportData = reportAPIResponse;
        }


        const newProductReport = { "product_code": productCode, "data": processedReportData };
        setProductReportdata((productReportData) => {
            const index = productReportData.findIndex(p => p.product_code === newProductReport.product_code);
            if (index > -1) {
                return productReportData.map((p, i) => i === index ? newProductReport : p);
            } else {

                return [...productReportData, newProductReport];
            }
        });


        setTabLoader([...tabLoader, productCode]);


    }

    function getTabreport(pcode) {

        const index = productReportData.findIndex(item => item.product_code === pcode);
        return productReportData[index].data;

    }



    const handleGroupChange = (selectedGroup) => {
        if (selectedGroup.length > 20) {
            alert('Maximum of 20 products can be selected at a time. Please remove extra products.');
        } else {
            setSelectedGroup(selectedGroup);
        }
    }

    const handleProductChange = (selectedGroup) => {
        if (selectedGroup.length > 20) {
            alert('Maximum of 20 products can be selected at a time. Please remove extra products.');
        } else {
            setSelectedGroup(selectedGroup);
        }
    }


    const handleExportSheet = async () => {

        var reportJson = {};
        reportJson.fileName = reportGenData.title + ".xlsx";
        reportJson.title = reportGenData.title;
        reportJson.author = "Aristo Pharma";
        var decimal_indexes = [];
        reportJson.sheets = [
            {
                name: "Sheet 1",
                data: []
            }
        ]

        const columns = Object.keys(reportGenData.data[0]).filter(key => key !== 'color');
        const headerFormatted = columns.map(key => getHeaderColNames(key));

        reportJson.sheets[0].data.push({
            backgroundColor: "#0043a9",
            fontColor: "#FFFFFF",
            fontSize: 13,
            bold: true,
            values: headerFormatted
        });

        const backgroundColors = {
            0: "", // 0
            1: "#5892C6", // 1
            2: "#3553DE"  // 2
        };

        reportGenData.data.forEach(item => {
            const row = {
                backgroundColor: backgroundColors[item.color] || "",
                fontColor: item.color === 2 ? "#333333" : "#333333",
                fontSize: 12,
                bold: false,
                //  values: columns.map(col => item[col])
                values: columns.map((col, colIndex) => {
                    let value = item[col];

                    if (Array.isArray(reportGenData.decimal_keys) && reportGenData.decimal_keys.length > 0) {
                        if (reportGenData.decimal_keys.includes(col)) {
                            if (!decimal_indexes.includes(colIndex)) {
                                decimal_indexes.push(colIndex);
                            }
                        }
                    }

                    return value;
                })
            };
            reportJson.sheets[0].data.push(row);
        });

         generateExcel(reportJson,20,40,0,3,[],decimal_indexes).catch(console.error);

    }

    const handleReportGen = async () => {

        console.log(SelectedGroup);

        if (SelectedGroup.length == 0 || SelectedGroup == 0) {
            alert('Select aleast one group');
            return;
        }

        generateProductReport(SelectedGroup[0].value);
        setShowOptions(false);
        return;
    }


    const handleTabChange = (groupCode) => {
        if (!tabLoader.includes(groupCode)) {
            generateProductReport(groupCode);
        } else {

        }
    }



    const handleExportMultiSheet = async () => {

        setMultiSheetDownloadStart(true);
        if (SelectedGroup.length !== productReportData.length) {
            for (let i = 0; i < SelectedGroup.length; i++) {
                setSheetLoaderMessage("Processing data for group #" + SelectedGroup[i].value);
                await generateProductReport(SelectedGroup[i].value);
            }
            setReportGenerationCompleted(true);
        } else {
            setReportGenerationCompleted(true);
        }

    }


    const loadGroupList = async (div, year) => {
        setGroupLoader(true);
        setSelectedGroup({});
        const grouplistAPIResponse = await proxy(`/api/mis/grouplist/${div}/${year}`, {}, "get");
        const converted_list = convertGroupData(grouplistAPIResponse);

        setGroupListItems(converted_list);
        setGroupLoader(false);
        setSelectedGroup(0);

    }


    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);
    }

    function convertGroupData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['value'],
                label: item['name']
            }));
            return converted_list;
        }
        return [];
    }

    const handleYearChange = async (newYear) => {

        setSelectedYear(newYear);
        loadGroupList(SelectedDiv, newYear);
    }

    useEffect(() => {
        //  loadProductItems(SelectedDiv, SelectedYear);
        loadGroupList(SelectedDiv, SelectedYear);
        transformNavDataForLabels("BM13").then(title => {
            setPageTitle(title);
        });


    }, []);

    return (
        <>
            <div class="main-content">
                {showProcessLoader && <ProcessLoader />}
                {showOptions ?
                    <ReportOptions title={pageTitle} >
                        <div className="report-option-wrapper">
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label>Division</label>
                                    <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); loadGroupList(newVal, SelectedYear); }} />
                                </div>

                                <div className="report-option-item ml-20">
                                    <label>Branch</label>
                                    <DropDownControl data={depo_data.data} id="report_branch_list" name="report_branch_list"

                                        onChange={(newBranch) => { handleBranchChange(newBranch); }}
                                    />
                                </div>

                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item ">
                                    <label>Mkt&nbsp;Year</label>
                                    <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" onChange={(newYear) => { handleYearChange(newYear) }} />

                                </div>

                                <div className="report-option-item ml-10">
                                    <label>From</label>
                                    <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { console.log(val); setSelectedStartMonth(val) }} />
                                </div>
                                <div className="report-option-item ml-10">
                                    <label>To</label>
                                    <DropDownControl data={month_data.data} id="report_endyear_list" name="report_endyear_list" selectedValue={SelectedEndMonth} onChange={(val) => { console.log(val); setSelectedEndMonth(val) }} />
                                </div>

                            </div>
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_uv" checked={(true && unitValue === 1)}
                                        onChange={(e) => { setUnitvalue(1);; }} />
                                    <label>Unit</label>
                                </div>
                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_uv" checked={(true && unitValue === 2)}
                                        onChange={(e) => { setUnitvalue(2); }} />
                                    <label>Value</label>
                                </div>


                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_rptype" checked={(true && ReportType === 1)}
                                        onChange={(e) => { setReportType(1);; }} />
                                    <label>Branchwise</label>
                                </div>
                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_rptype" checked={(true && ReportType === 2)}
                                        onChange={(e) => { setReportType(2);; }} />
                                    <label>Hqwise</label>
                                </div>


                            </div>




                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_itemtype" checked={(true && itemType === 1)}
                                        onChange={(e) => { setItemType(1);; loadGroupList(SelectedDiv, SelectedYear); setUnitvalue(2); handleGroupChange([]) }} />
                                    <label>Groupwise</label>
                                </div>
                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_itemtype" checked={(true && itemType === 2)}
                                        onChange={(e) => { setItemType(2); loadProductItems(SelectedDiv, SelectedYear); handleGroupChange([]) }} />
                                    <label>Productwise</label>
                                </div>


                            </div>




                            {itemType == 2 &&
                                <div className="report-option-row">
                                    <div className="report-option-item">
                                        <label >Select&nbsp;Product</label>
                                        {productlistLoading ? <BrandedLoader /> :
                                            <MultiSelectOptions
                                                itemsData={productListItems}
                                                onChange={handleGroupChange}
                                            />}

                                    </div>
                                </div>
                            }
                            {itemType == 1 &&
                                <div className="report-option-row">
                                    <div className="report-option-item">
                                        <label >Select&nbsp;Group</label>
                                        {groupLoader ? <BrandedLoader /> :
                                            <MultiSelectOptions
                                                itemsData={GroupListItems}
                                                onChange={handleGroupChange}
                                            />}

                                    </div>
                                </div>
                            }













                            <div className="report-option-action-row">
                                <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                                <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                            </div>
                        </div>
                    </ReportOptions>
                    :
                    <>
                        {true ?
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card report-card" style={{ width: "auto" }}>
                                            <div className="card-title report-card-title">{'10-Selective Product Mnth/Cumm Form 6'}
                                                <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                                            </div>
                                            <div className="card-body card-body-multireport">


                                                <ul class="nav nav-tabs nav-tabs-light-mode nav-justified" role="tablist">

                                                    {SelectedGroup.map((product, index) => (

                                                        <li key={product.value} class="nav-item ">
                                                            <a class={`nav-link ${index == 0 && 'active'}`} onClick={() => { handleTabChange(product.value) }} data-toggle="tab" href={`#tab${product.value}`} role="tab">{product.label}</a>
                                                        </li>

                                                    ))}

                                                </ul>

                                                <div class="tab-content">
                                                    {SelectedGroup.map((product, index) => (

                                                        <div key={product.value} className={`tab-pane fade ${index == 0 && 'active show'}`} id={`tab${product.value}`}>

                                                            {
                                                                tabLoader.includes(product.value) ?

                                                                    <>
                                                                        <h3 className="fs-16 fw-500">{getTabreport(product.value).title}</h3>

                                                                        {getTabreport(product.value).data.length > 0 ? <DynamicDTFloatTabs
                                                                            fixedColumns={true}
                                                                            tableData={getTabreport(product.value)}
                                                                            tableID={`tabledt_${product.value}`}
                                                                            firstColWidth="220px"
                                                                            secColWidth="90px"

                                                                            handleExportSheet={handleExportMultiSheet}
                                                                            forceDecimal={reportGenData.decimal_keys?.length > 0}
                                                                            decimalKeys={reportGenData.decimal_keys}

                                                                        /> : <p className="alert alert-secondary" role="alert">No data for this product.</p>}

                                                                    </>
                                                                    : <BrandedLoader />
                                                            }


                                                        </div>
                                                    ))}


                                                </div>

                                            </div>
                                            <div className="card-footer">


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card report-card" style={{ width: "auto" }}>
                                            <div className="card-title report-card-title">{reportGenData.title}
                                                <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                                            </div>
                                            <div className="card-body">
                                                <DynamicDTFloat
                                                    tableData={reportGenData}

                                                    handleExportSheet={handleExportSheet}
                                                    firstColWidth="200px"
                                                    secColWidth="100px"
                                                    fixedColumns={true}
                                                />

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </>
                }
                {MultiSheetDownloadStart && <MultiSheetProcessingLoader title="Please wait while we download the excel file." loadingText={sheetloaderMessage} />}

            </div>
        </>
    );


}

export default BM13;